import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    getLanguageLocale,
    getLanguageName,
    languageOptions,
    LanguageOption,
} from 'src/services/language-service';
import { useAppDispatch } from 'src/redux/hooks';
import { themeActions } from 'src/features/theme/redux/theme-slice';

const LanguageMenu = () => {
    const dispatch = useAppDispatch();
    const [anchorElLang, setAnchorElLang] = useState<null | HTMLElement>(null);
    const { i18n } = useTranslation();

    const language = useMemo(() => getLanguageName(i18n.language), [i18n.language]);

    const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElLang(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorElLang(null);
    };

    const handleItemClick = (option: LanguageOption) => {
        setAnchorElLang(null);
        i18n.changeLanguage(option.langCode);
        dispatch(themeActions.setLocale(getLanguageLocale(option.langCode)));
    };

    const LanguageMenuItems = ({ options }: { options: LanguageOption[] }) => {
        return (
            <>
                {options.map((option) => (
                    <MenuItem
                        key={option.langCode}
                        disabled={option.langCode === i18n.language}
                        onClick={() => handleItemClick(option)}
                    >
                        <Typography textAlign="center">{option.name}</Typography>
                    </MenuItem>
                ))}
            </>
        );
    };

    return (
        <Box sx={{ flexGrow: 0 }}>
            <Button
                variant="text"
                onClick={handleOpen}
                aria-label="language menu"
                aria-controls="menu-language"
                aria-haspopup="true"
                color="inherit"
            >
                <Typography textAlign="center">{language}</Typography>
            </Button>

            <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElLang}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={Boolean(anchorElLang)}
                onClose={handleClose}
            >
                <LanguageMenuItems options={languageOptions} />
            </Menu>
        </Box>
    );
};

export default LanguageMenu;
